import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { GfTranslateService } from '../../core/services/core.translate.service';
import { DocmanFolderModel } from './services/docman.model.folder';
import { UiService } from '../../core/services/core.ui.service';

function findFolderInPath(foldersTree, arrPath) {
    var treeLevel = foldersTree[0].nodes,
        targetFolder = null;

    for (var i = 0; i < arrPath.length; i++) {
        if (_.isEmpty(arrPath[i])) {
            continue;
        }

        targetFolder = _.find(treeLevel, { title: arrPath[i] });

        //if not found, then break
        if (!targetFolder) {
            break;
        }

        //Otherwise, go to next tree level
        treeLevel = targetFolder.nodes;
    }

    return targetFolder;
}

@Injectable()
export class DocmanResolvesService {

    constructor(
        private translateService: GfTranslateService,
        private docmanFolderModel: DocmanFolderModel,
        private uiService: UiService
    ) {
    }

    security(project: any, ProjectModel: any) {
        return ProjectModel.checkPermission(project, 'docman');
    }

    tour(TourService: any) {
        return TourService.setTour('docsHomeCtrl');
    }

    async data(project: any, path?: string, folder?: number) {
        const ret = {
            folders: null,
            foldersTree: null,
            folder: null
        };

        try {
            const response = await this.docmanFolderModel.getFolders(project);
            ret.folders = response;
            ret.foldersTree = [this.docmanFolderModel.createFolderTree(project)];
            let folderId = null;

            if (folder) {
                folderId = folder;
            } else {
                const decodedPath = path ? decodeURIComponent(decodeURIComponent(path)) : '';
                const folderFromPath = findFolderInPath(ret.foldersTree, decodedPath.split('/')) ||
                    this.docmanFolderModel.getRootId();

                // If folder is still not set, it means
                // the user can't see the root (incoming) folder.
                if (_.isEmpty(folderFromPath)) {
                    this.uiService.message.showError(
                        this.translateService.translate("Sorry, you don't have access to the root folder.  Check with your Project Admin or a GForge Administrator for assistance."),
                        this.translateService.translate("Not Allowed")
                    );
                    throw new Error("No access to root folder");
                }
                folderId = folderFromPath.id;
            }

            try {
                const folderResponse = await this.docmanFolderModel.getFolder(folderId);
                ret.folder = folderResponse;
                return ret;
            } catch (error) {
                this.uiService.message.showError(
                    this.translateService.translate("Sorry, could not find the folder you requested."),
                    this.translateService.translate("Folder Not Found")
                );
                throw error;
            }
        } catch (error) {
            this.uiService.message.showError(
                this.translateService.translate("Sorry, an error occurred."),
                this.translateService.translate("Not Available")
            );
            throw error;
        }
    }
}
